import React from "react";
import PT from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import userIcon from "../../../../assets/images/user.svg";
import { IS_OPEN_LOGIN_FORM, USER_SUBSCRIPTION, USER_SUBSCRIPTION_LOADING } from "../../helper/actions";
import { ACCOUNT_DETAILS_URL } from "../../../constants";
import IntegrationData from "../../../../../config/integrations.js";
import "./user-data.m.css";
import { AccessType } from "@quintype/components";

class UserDataBaseHandler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showUserData: false
    };
  }

  componentDidMount() {
    const userSubscription = () => this.subscriptonDetails();
    this.props.initAccessType(userSubscription);
  }

  subscriptonDetails = async () => {
    this.props.userSubscriptionDetailsLoading();
    const res = await this.props
      .getSubscriptionForUser()
      .then(({ subscriptions = [] }) => {
        const hasSub = subscriptions
          .filter(subscription => subscription.active === true)
          .filter(item => get(item, ["assets", 0, "type"], "") === "site");
        if (hasSub.length > 0) {
          this.props.userSubscriptionDetails({
            userHasSubscription: true,
            userSubscription: subscriptions,
            loading: false
          });
        } else {
          this.props.userSubscriptionDetails({
            userHasSubscription: false,
            userSubscription: subscriptions,
            loading: false
          });
        }

        return subscriptions;
      })
      .catch(error => {
        console.log("error while fetching subscription", error);
        return error;
      });
    return res;
  };

  logoutHandler = event => {
    event.persist();
    event.preventDefault();
    event.stopPropagation();
    this.props
      .logout()
      .then(() => {
        this.props.onBackdropClick(false);
        this.props.manageLoginForm(false);
        this.setState({ showUserData: !this.state.showUserData });
      })
      .catch(error => {
        console.warn("Logout failed", error);
        return null;
      });
  };

  profileHandler = () => {
    this.setState({ showUserData: !this.state.showUserData });
    this.props.navigateTo(ACCOUNT_DETAILS_URL);
  };

  render() {
    const { member = {}, publisherConfig } = this.props;
    const imageUrl = member["avatar-s3-key"] ? publisherConfig["cdn-image"] + member["avatar-s3-key"] : userIcon;

    return (
      <div styleName="wrapper">
        <div styleName="user-details" onClick={() => this.setState({ showUserData: !this.state.showUserData })}>
          <img src={imageUrl} styleName="memberIcon" />
        </div>
        {this.state.showUserData && (
          <div styleName="overlay">
            <ul styleName="lists">
              <li onClick={this.profileHandler}>My Profile</li>
              <li onClick={this.logoutHandler}>Logout</li>
            </ul>
          </div>
        )}
      </div>
    );
  }
}

UserDataBaseHandler.propTypes = {
  logout: PT.func,
  onBackdropClick: PT.func,
  member: PT.object,
  publisherConfig: PT.object,
  manageLoginForm: PT.func,
  navigateTo: PT.func,
  initAccessType: PT.func,
  getSubscriptionForUser: PT.func,
  userSubscriptionDetails: PT.func,
  userSubscriptionDetailsLoading: PT.func
};

const userDataBase = props => {
  const integrationsConfig = IntegrationData();
  const email = get(props, ["member", "email"], "");
  const phone = get(props, ["member", "metadata", "phone"], "");
  const isStaging = get(props.publisherConfig, ["publisher", "accessTypeEnvironment"], true);
  const accessTypeKey = isStaging ? integrationsConfig.stagingAccessTypeKey : integrationsConfig.accessTypeKey;

  const enableAccesstype = get(props.publisherConfig, ["publisher", "enableAccesstype"], true);
  const accessTypeBkIntegrationId = isStaging
    ? integrationsConfig.stagingAccessTypeBkIntegrationId
    : integrationsConfig.accessTypeBkIntegrationId;
  return (
    <div>
      <AccessType
        enableAccesstype={enableAccesstype}
        isAccessTypeCampaignEnabled={true}
        isStaging={isStaging}
        accessTypeKey={accessTypeKey}
        email={email}
        phone={phone}
        accessTypeBkIntegrationId={accessTypeBkIntegrationId}
      >
        {({ initAccessType, getSubscriptionForUser }) => {
          return (
            <UserDataBaseHandler
              initAccessType={initAccessType}
              getSubscriptionForUser={getSubscriptionForUser}
              {...props}
            />
          );
        }}
      </AccessType>
    </div>
  );
};

userDataBase.propTypes = {
  publisherConfig: PT.object
};

const mapDispatchToProps = dispatch => ({
  manageLoginForm: function(payload) {
    dispatch({
      type: IS_OPEN_LOGIN_FORM,
      payload: payload
    });
  },
  navigateTo: url => global.app.navigateToPage(dispatch, url),
  userSubscriptionDetails: function(payload) {
    dispatch({
      type: USER_SUBSCRIPTION,
      payload: payload
    });
  },
  userSubscriptionDetailsLoading: function(payload) {
    dispatch({
      type: USER_SUBSCRIPTION_LOADING
    });
  }
});

const mapStateToProps = state => ({
  publisherConfig: get(state, ["qt", "config", "publisher"], {})
});

export const UserData = connect(mapStateToProps, mapDispatchToProps)(userDataBase);
